module.exports = __webpack_public_path__ + "media/reskin-images/img--no-notes-taken-55597eab.png";